import { observer } from 'mobx-react-lite';
import { FC, MouseEventHandler } from 'react';

import { PlayIcon, PlayIconState, PlayIconType, TPlayIconTheme } from '@gem/ui-kit';

import {
  IFileUploadStateData,
  useFileUploadStatePresenter,
} from 'APP/hooks/useFileUploadState/useFileUploadState';

interface IAudioUploadStateProps {
  uploadFileData: IFileUploadStateData;
  className?: string;
  onClick?: MouseEventHandler<SVGSVGElement | SVGGElement>;
  iconType?: PlayIconType;
  theme?: TPlayIconTheme;
}

export const AudioUploadState: FC<IAudioUploadStateProps> = observer((props) => {
  const { uploadFileData, className, onClick, iconType = PlayIconType.Play, theme = '0' } = props;

  const presenter = useFileUploadStatePresenter(uploadFileData);

  let state;

  if (presenter.hasError) {
    state = PlayIconState.Error;
  } else if (presenter.isWaitingUploadProcess) {
    state = PlayIconState.Infinity;
  } else if (presenter.isUploadProcess) {
    state = PlayIconState.Loading;
  } else {
    state = PlayIconState.Regular;
  }

  return (
    <div className={className}>
      <PlayIcon
        type={iconType}
        theme={theme}
        state={state}
        progress={presenter.uploadProgress || 0}
        onCancel={presenter.cancelUpload}
        onClick={onClick}
      />
    </div>
  );
});
